// Máscaras aplicadas na digitação, escolhidas pelo laytel.tipinp (cep, cgc, ncm)

const digitos = (valor: string, limite: number) => String(valor ?? '').replace(/\D/g, '').slice(0, limite);

// 00000-000
export function mascaraCep(valor: string) {
  return digitos(valor, 8).replace(/^(\d{5})(\d)/, '$1-$2');
}

// CPF (000.000.000-00) até 11 dígitos; a partir do 12º vira CNPJ (00.000.000/0000-00)
export function mascaraCgc(valor: string) {
  const v = digitos(valor, 14);

  if (v.length <= 11) {
    return v
      .replace(/^(\d{3})(\d)/, '$1.$2')
      .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1-$2');
  }

  return v
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2');
}

// 0000.00.00, como o ERP desktop grava o NCM
export function mascaraNcm(valor: string) {
  return digitos(valor, 8)
    .replace(/^(\d{4})(\d)/, '$1.$2')
    .replace(/^(\d{4})\.(\d{2})(\d)/, '$1.$2.$3');
}

const MASCARAS: Record<string, { aplicar: (valor: string) => string; tamanho: number }> = {
  cep: { aplicar: mascaraCep, tamanho: 9 },
  cgc: { aplicar: mascaraCgc, tamanho: 18 },
  ncm: { aplicar: mascaraNcm, tamanho: 10 }
};

export function mascaraPorTipo(tipinp?: string) {
  return tipinp ? MASCARAS[tipinp.toLowerCase()] : undefined;
}
